import { memo } from 'react';

import InterText from 'shared/InterText';

import { DEFAULT_TRANSITION } from 'constants/global';

const InputsLabelText = ({ value, label, ...props }) => (
  <InterText
    bgColor="ourWhite"
    pos="absolute"
    top={{ mobile: '-9px', laptop: '-11px' }}
    overflow="hidden"
    transition={DEFAULT_TRANSITION}
    noOfLines={1}
    zIndex="20"
    ms={{ mobile: '18px', tablet: '22px' }}
    px="2px"
    fontSize={{ mobile: '12px', laptop: '14px' }}
    lineHeight="140%"
    fontWeight="400"
    letterSpacing="0"
    opacity={value?.length ? 1 : 0}
    transform={value?.length ? 'translateY(0px)' : 'translateY(10px)'}
    color="ourGrayTwo"
    {...props}
  >
    {label}
  </InterText>
);

export default memo(InputsLabelText);
